<!-- {{ videoInfo.pipeS3Link }}<br />
{{ videoInfo.snapshotURL }} -->
<div class="crm-modal-content crm-page-wrapper">
  <div class="modal-header">
    <div class="modal-title text-uppercase">
      <h2>
        {{ dialogParams?.customerData?.displayName }}
        <span>{{ dialogParams?.customerData?.nic || dialogParams?.customerData?.passport }}</span>
      </h2>
    </div>
    <a class="close" (click)="cancelDialog(false)">&times;</a>
  </div>
  <div class="modal-body">
    <video src="{{ src }}" autoplay width="100%" poster="http://{{ videoInfo.snapshotURL }}" controls></video>
  </div>
</div>
